import { Controller } from "stimulus"

export default class extends Controller {

    calculateProfit() {
        var isFormValid = document.getElementById("cost").checkValidity() && document.getElementById("margin").checkValidity()
        if (isFormValid) {
            var cost = Number(document.getElementById("cost").value) || 0;
            var margin = Number(document.getElementById("margin").value) || 0;
            var salePrice, profit, grossMargin;
            var format = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
            });
            salePrice = cost * (100 + margin) / 100;
            profit = salePrice - cost;
            grossMargin = profit * 100 / salePrice || 0;
            document.getElementById("sale-price").innerText = `${format.format(salePrice)}`;
            document.getElementById("profit").innerText = `${format.format(profit)}`;
            document.getElementById("gross-margin").innerText = `${grossMargin.toFixed('2')}%`;
            document.getElementById("profit-calculation").classList.remove("hidden");
        }
    }

    reset() {
        document.getElementById("cost").value = null
        document.getElementById("margin").value = null
        document.getElementById("sale-price").innerText = '';
        document.getElementById("profit").innerText = '';
        document.getElementById("gross-margin").innerText = '';
        document.getElementById("cost").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("cost").classList.remove("pt-4");
        document.getElementById("margin").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("margin").classList.remove("pt-4");
        document.getElementById("profit-calculation").classList.add("hidden");
    }

    toggleLabel(event) {
        if (event.target.value.length == 0) {
            event.target.previousSibling.previousSibling.classList.add("opacity-0");
            event.target.classList.remove("pt-4");
        } else {
            event.target.previousSibling.previousSibling.classList.remove("opacity-0");
            event.target.classList.add("pt-4");
        }
    }
}